import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getConfigurationSchedule,
  getConfigurationScheduleErrors,
  getCurrentBellSchedule,
} from 'services/api';
import type { ScheduleFilters } from 'shared/api';

export const getScheduleAction = createAsyncThunk(
  'schedule/get',
  async ({
    curriculumId,
    scheduleId,
    filters,
  }: {
    curriculumId: string;
    scheduleId: string;
    filters?: ScheduleFilters;
  }) => {
    try {
      return await getConfigurationSchedule(curriculumId, scheduleId, filters);
    } catch (error: unknown) {
      throw new Error(error as string);
    }
  },
);

export const getScheduleErrorsAction = createAsyncThunk(
  'schedule/errors/get',
  async ({
    configurationId,
    scheduleId,
    filters,
  }: {
    configurationId: string;
    scheduleId: string;
    filters?: ScheduleFilters;
  }) => {
    try {
      const report = await getConfigurationScheduleErrors(configurationId, scheduleId, filters);
      return report;
    } catch (error: unknown) {
      throw new Error(error as string);
    }
  },
);

export const getCurrentBellScheduleAction = createAsyncThunk(
  'schedule/bell-schedule/getCurrent',
  async () => {
    try {
      return await getCurrentBellSchedule();
    } catch (error: unknown) {
      throw new Error(error as string);
    }
  },
);
